import { useHistory, useLocation } from 'react-router-dom'
import { useFormContext } from 'react-hook-form'
import { markdownToDraft } from 'markdown-draft-js'
import { useWizardFormContext } from 'components/wizard-form/context'

const STASHED_EVENT_FORM_VALUES = 'STASHED_EVENT_FORM_VALUES'

const stashEventFormValues = event => {
  window.sessionStorage.setItem(
    STASHED_EVENT_FORM_VALUES,
    JSON.stringify(event),
  )
}

const popEventFormValues = () => {
  const event = JSON.parse(
    window.sessionStorage.getItem(STASHED_EVENT_FORM_VALUES),
  )
  window.sessionStorage.removeItem(STASHED_EVENT_FORM_VALUES)
  return event
}

const useLoadGroupEventFormValues = () => {
  const history = useHistory()
  const { pathname } = useLocation()
  const form = useFormContext()

  const isOnCreateEventPage = pathname === '/pga-coach/bookings/events/new'
  const isOnOnboardingCreateEventPage =
    pathname === '/pga-coach/onboarding/bookings/events/new'

  const loadGroupEventFormValues = event => {
    if (isOnCreateEventPage || isOnOnboardingCreateEventPage) {
      hydrateEventFormValuesIntoForm(form, { event })
    } else {
      stashEventFormValues(event)
      history.push('/pga-coach/bookings/events/new?preload')
    }
  }

  return loadGroupEventFormValues
}

const buildHydratedEventFormValues = event => {
  const hydratedValues = {}

  if (event.title != null) {
    hydratedValues.title = event.title
  }

  if (event.description != null) {
    hydratedValues.description = JSON.stringify(
      markdownToDraft(event.description),
    )
  }

  if (event.academyRequired != null) {
    hydratedValues.academyRequired = event.academyRequired
  }

  if (event.tags != null) {
    hydratedValues.tags = event.tags
  }

  if (event.coachFacility?.id != null) {
    hydratedValues.locationId = event.coachFacility.id
  }

  if (event.featuredImageUrl != null) {
    hydratedValues.featuredImageUrl = event.featuredImageUrl
  }

  if (event.priceInCents != null) {
    hydratedValues.price = event.priceInCents / 100
  }

  if (event.collectAttendance != null) {
    hydratedValues.collectAttendance = event.collectAttendance
  }

  if (event.template != null) {
    hydratedValues.templateId = event.template.id ?? null
  }

  return hydratedValues
}

const hydrateEventFormValuesIntoForm = (
  form,
  { advance, event: eventOverride } = {},
) => {
  const event = eventOverride || popEventFormValues()
  if (!event) return

  form.reset({
    ...form.getValues(),
    ...buildHydratedEventFormValues(event),
  })
  advance?.()
}

const useHydrateEventFormValues = () => {
  const form = useFormContext()
  const wizardForm = useWizardFormContext()

  return () =>
    hydrateEventFormValuesIntoForm(form, { advance: wizardForm.advance })
}

export {
  useLoadGroupEventFormValues,
  useHydrateEventFormValues,
  hydrateEventFormValuesIntoForm,
  buildHydratedEventFormValues,
}
